import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { configAPI } from 'redux/configAPI';

export const getConfig = createAsyncThunk('getConfig', async () => {
  return configAPI.getConfig();
});

const initialState = {
  env: {
    enableClientCredentialsLogin: false,
  },
  settlements: {
    maxSettlementsPerCsv: 100,
  },
  error: null,
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    resetError: (state, _) => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(getConfig.fulfilled, (state, { payload }) => ({ ...initialState, ...payload }));
    builder.addCase(getConfig.rejected, (state, { error }) => ({ ...initialState, error }));
  },
});

const { actions } = configSlice;
export const { resetError } = actions;
export const { reducer: configReducer } = configSlice;
